// Core Modules
import React, { Component } from 'react';
// import {Link} from 'react-router-dom';
// Components
import Sidebar from '../../components/Sidebar/Sidebar';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
// Styles
import '../assets/css/material-dashboard.css';
// Dependancy Modules
import Avatar from 'react-avatar';
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
// import swal from 'sweetalert';
import PacmanLoader from "react-spinners/PacmanLoader";
// import axios from 'axios';

class Home extends Component {
    
    state = { 
        uid: firebase.auth().currentUser.uid,
        name: '',
        username: '',
        course: '',
        isLoading: false
        // passChanging: false,
        // currentPsd: '',
        // newPsd: '',
        // conPsd: ''
    }

    componentDidMount = () => {
        if (!!document.getElementsByClassName('nav-open')[0]) {
            document.getElementsByClassName('nav-open')[0].classList.remove('nav-open');
        }
        this.setState({isLoading: true});
        firebase.database().ref(`/students/${this.state.uid}`).once('value')
            .then((snapshot) => {
                let courseName = '';
                let snapData = snapshot.val();
                if (snapData.course[0] === 's') {
                    courseName = 'Plus Two';
                } else if (snapData.course[0] === 'j') {
                    courseName = 'Plus One';
                } else if (snapData.course[0] === 'a') {
                    courseName = '10th CBSE';
                } else {
                    courseName = 'Crash Course'
                }
                this.setState({name: snapshot.val().name, username: snapshot.val().id, course: courseName, isLoading: false});
            }).catch(e => console.error(e));
    }

    // changePasswordHandler = () => {
    //     if (this.state.passChanging === false) {
    //         this.setState({passChanging: true}); 
    //     }else {
    //         if (this.state.currentPsd === '' || this.state.newPsd === '' || this.state.conPsd === '') {
    //             this.setState({currentPsd: '', newPsd: '', conPsd: ''}, () => {
    //                 swal("", "Please fill all the fields", "warning");
    //             });
    //         }else {
    //             let currentPassword = JSON.parse(sessionStorage.getItem('auth_data'));
    //             if(currentPassword.password !== this.state.currentPsd){
    //                 this.setState({currentPsd: '', newPsd: '', conPsd: ''}, () => {
    //                     swal("", "Please check your current password", "warning");
    //                 });
    //             }else {
    //                 if (this.state.newPsd !== this.state.conPsd) {
    //                     this.setState({currentPsd: '', newPsd: '', conPsd: ''}, () => {
    //                         swal("", "Please enter same value for new password", "warning");
    //                     });
    //                 } else {
    //                     if (this.state.newPsd.split(" ").length > 1) {
    //                         this.setState({currentPsd: '', newPsd: '', conPsd: ''}, () => {
    //                             swal("", "New password can't contain white spaces", "warning");
    //                         });
    //                     } else {
    //                         if (this.state.newPsd.length < 8) {
    //                             this.setState({currentPsd: '', newPsd: '', conPsd: ''}, () => {
    //                                 swal("", "Password should have atleast 8 characters", "warning");
    //                             });
    //                         }else {
    //                             this.setState({passChanging: false, isLoading: true}, () => {
    //                                 let postUrl = 'https://us-central1-insightplus-mpm.cloudfunctions.net/app/changepwd';
    //                                 axios.post(postUrl, {
    //                                     username: currentPassword.username,
    //                                     currentpassword: this.state.currentPsd,
    //                                     newpassword: this.state.newPsd
    //                                 }).then(() => {
    //                                     firebase.auth().signOut()
    //                                         .then(() => {
    //                                             sessionStorage.setItem('auth_data', '');
    //                                             window.location.pathname = '/';
    //                                         });
    //                                 }).catch(err => {
    //                                     swal("", err.message, "error").then(() => {
    //                                         window.location.reload();
    //                                     });
    //                                 })
    //                             });
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // }

    // currentPsdChangeHandler = (event) => {
    //     this.setState({currentPsd: event.target.value});
    // }

    // newPsdChangeHandler = (event) => {
    //     this.setState({newPsd: event.target.value});
    // }

    // conPsdChangeHandler = (event) => {
    //     this.setState({conPsd: event.target.value});
    // }
    
    render() { 
        let avatarColor = ['Red', 'Blue', 'Green', 'Black', 'Grey', 'Purple', 'Pink', 'Tomato', 'SlateBlue', 'Orange', 'DodgerBlue', 'MediumSeaGreen', 'Violet'];
        let randomColor = avatarColor[Math.floor(Math.random()*avatarColor.length)];
        return ( 
            <div className="wrapper ">
                <Sidebar />
                <div className="main-panel">
                    <Navbar />
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="card card-profile">
                                    <div className="card-avatar">
                                        <span>
                                            <Avatar color={randomColor} name={this.state.name} />
                                        </span>
                                    </div>
                                    <div className="card-body">
                                        {
                                            this.state.passChanging ? 
                                                <div className="row" style={{padding: '0 30px'}}>
                                                    <div className="col-md-12">
                                                        <i 
                                                            className="material-icons" 
                                                            style={{color: 'red', cursor: 'pointer'}}
                                                            onClick={() => {this.setState({passChanging: false});}}>
                                                                close
                                                        </i>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <input
                                                                onChange={this.currentPsdChangeHandler}
                                                                value={this.state.currentPsd}
                                                                placeholder="current password" 
                                                                type="password" 
                                                                className="form-control" 
                                                                style={{backgroundColor: 'white', boxShadow: 'none', textAlign: 'center'}}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <input
                                                                onChange={this.newPsdChangeHandler}
                                                                value={this.state.newPsd}
                                                                placeholder="new password" 
                                                                type="password" 
                                                                className="form-control" 
                                                                style={{backgroundColor: 'white', boxShadow: 'none', textAlign: 'center'}}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <input
                                                                onChange={this.conPsdChangeHandler}
                                                                value={this.state.conPsd}
                                                                placeholder="confirm new password" 
                                                                type="password" 
                                                                className="form-control" 
                                                                style={{backgroundColor: 'white', boxShadow: 'none', textAlign: 'center'}}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <p style={{textAlign: 'center', width: '100%', fontSize: '12px', color: 'black'}}>
                                                            <svg style={{width:'20px',height:'20px'}} viewBox="0 0 24 24">
                                                                <path fill="red" d="M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63M12,6A6,6 0 0,1 18,12C18,14.22 16.79,16.16 15,17.2V19A1,1 0 0,1 14,20H10A1,1 0 0,1 9,19V17.2C7.21,16.16 6,14.22 6,12A6,6 0 0,1 12,6M14,21V22A1,1 0 0,1 13,23H11A1,1 0 0,1 10,22V21H14M11,18H13V15.87C14.73,15.43 16,13.86 16,12A4,4 0 0,0 12,8A4,4 0 0,0 8,12C8,13.86 9.27,15.43 11,15.87V18Z" />
                                                            </svg>
                                                            &nbsp; Pro Tip : use combination of characters digits and symbols for a secure password 
                                                        </p>
                                                    </div>
                                                </div>
                                            :
                                                <React.Fragment>
                                                    <h6 className="card-category text-gray">{this.state.username}</h6>
                                                    <h4 className="card-title">{this.state.name}</h4>
                                                    <p className="card-description">
                                                        {this.state.course}
                                                    </p>
                                                </React.Fragment>
                                        }
                                        <div className="card-description" style={{width: '100%'}}>
                                            <PacmanLoader
                                                css={{display: 'block', margin: '0 auto 30px'}}
                                                size={20}
                                                color={randomColor}
                                                loading={this.state.isLoading} />
                                        </div>
                                        {/* {
                                            this.state.isLoading ? null :
                                            <button 
                                                className="btn btn-round" 
                                                onClick={this.changePasswordHandler}
                                                style={{background: randomColor}}>
                                                    Change Password
                                            </button>
                                        }                                      */}
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}
 
export default Home;